import { Dispatch } from "redux";
import { captureException } from "@sentry/react";
import { AxiosInstance, AxiosResponse } from "axios";
import { showNotification } from "../../notification/actions";
import { PlanActionTypes } from "../models/planActions";
import { IStateTree } from "../../interfaces";
import { ICover } from "../../../pages/plan/MiddleRow/Image/interfaces";

export default (callback: (res: AxiosResponse<ICover[]>) => void) => async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.get<ICover[]>("/get-plan-covers");
        callback(res);
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};
